import { useState, useCallback } from 'react';
import useLab2PageState from 'features/lab2/hooks/useLab2PageState';

const DEFAULT_RADIUS = 1000;

export default function useLifestyleAppState() {
    const labState = useLab2PageState();
    const [isMapAreaSelectMode, setIsMapAreaSelectMode] = useState(false);
    const [radius, setRadius] = useState(DEFAULT_RADIUS);
    const [type, setType] = useState('hos');
    const [admCd, setAdmCd] = useState();
    const [selectedLocation, setSelectedLocation] = useState(null);

    const handleMapAreaSelect = useCallback(() => {
        setIsMapAreaSelectMode(true);
    }, []);

    const handleMapAreaReset = useCallback(() => {
        setIsMapAreaSelectMode(false);
        setSelectedLocation(undefined);
    }, []);

    return {
        ...labState,
        isMapAreaSelectMode,
        setIsMapAreaSelectMode,
        radius,
        setRadius,
        type,
        setType,
        admCd,
        setAdmCd,
        selectedLocation,
        setSelectedLocation,
        handleMapAreaSelect,
        handleMapAreaReset,
    };
}
